import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import {
	TRevenueSpendByTeam, TRevenueSpendByTeamSpend
} from '../../types'
import { ToolPanel } from '../ui'
import { RevenueSpendByTeamSpendDetailsTable } from './RevenueSpendByTeamSpendDetailsTable'
import dt from 'dayjs'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IRevenueSpendByTeamSpendDetailsModal = {
	revenueSpend: TRevenueSpendByTeam | TRevenueSpendByTeamSpend | null;
	show: boolean;
	take: number | 'all';
	onClose: () => void;
}

export const RevenueSpendByTeamSpendDetailsModal = (
	props: IRevenueSpendByTeamSpendDetailsModal
) => {
	const { revenueSpend, show, take = 10, onClose } = props
	const { t } = useTranslation()
	const [page, setPage] = useState<number>(0)
	const skip = (take === 'all') ? 0 : page > 0 ? page * take : 0

	const _getDateFormat = (at: Date) => {
		return dt.utc(at).isValid() ? dt.utc(at).format('L') : '-'
	}

	const isSingleView = !!(revenueSpend && ('teamReport' in revenueSpend))
	const teamLabel = isSingleView && `'${revenueSpend?.teamReport ?? ''}'`
	const dayLabel = isSingleView && _getDateFormat(revenueSpend?.at)

	return <>
		<Modal show={show} onHide={onClose} size="xl" className={'modal-with-sticky scroll'}>
			<Modal.Header className={'modal-header--sticky'} closeButton>
				<Modal.Title>
					{
						isSingleView ?
							`${t(ALL_LANG_KEY.revenue_spend_crud_modal.title_by_team_spend, {
								team: teamLabel,
								date: dayLabel
							})}` :
							`${t(ALL_LANG_KEY.revenue_spend_crud_modal.title_by_team_spend_total)}`
					}
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<RevenueSpendByTeamSpendDetailsTable
					items={revenueSpend?.spend ?? []}
					skip={skip}
				/>
			</Modal.Body>

			<Modal.Footer className={'modal-footer--sticky'}>
				<ToolPanel flow="<-" width={'100%'}>
					<Button variant="secondary"
					        onClick={onClose}
					>
						{`${t(ALL_LANG_KEY.revenue_spend_crud_modal.btn_close)}`}
					</Button>
				</ToolPanel>

			</Modal.Footer>
		</Modal>
	</>
}
